const roleActions = {
  MAX_ITEMS: 6,
};

export default roleActions;
